import { IdGrupo, IdUsuario } from "../common-types";
import { GenericServiceBase } from "../generic-service";

export class GrupoWhitelistService extends GenericServiceBase {
    constructor() { super('group-whitelist') }
    
    async whitelistUser(idGrupo: IdGrupo, idUsuario: IdUsuario): Promise<void> {
        await this.f.put(`/${idGrupo}/${idUsuario}`);
    }

    async unwhitelistUser(idGrupo: IdGrupo, idUsuario: IdUsuario): Promise<void> {
        await this.f.delete(`/${idGrupo}/${idUsuario}`);
    }

    async clearWhitelist(idGrupo: IdGrupo): Promise<void> {
        await this.f.delete(`/clear/${idGrupo}`);
    }
}